export default function Hero() {
  const handleCall = () => {
    window.location.href = 'tel:+68987735594';
  };

  const handleDirections = () => {
    window.open('https://maps.google.com/?q=Moorea-Maiao+98728+Polynésie+française', '_blank');
  };

  const handleAvis = () => {
    window.open('https://www.google.com/search?q=KEIKI+Moorea+avis', '_blank');
  };

  return (
    <section className="relative h-screen flex items-start justify-center overflow-hidden pt-24">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/8396d9597f4692c6c57ab88458ad29d4.png"
          alt="KEIKI Restaurant Moorea"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        {/* Overlay flou centré derrière le texte */}
        <div className="absolute inset-0 -z-10 rounded-3xl bg-gradient-to-b from-black/50 via-black/40 to-black/50 blur-sm"></div>
        <div className="space-y-8">
          <h1 className="text-7xl sm:text-8xl lg:text-9xl font-serif text-white mb-6 tracking-tight" style={{textShadow: '0 2px 16px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.9)'}}>
            KEIKI
          </h1>
          
          <div className="space-y-3">
            <p className="text-3xl sm:text-4xl lg:text-5xl text-white font-light tracking-wider leading-tight" style={{textShadow: '0 2px 12px rgba(0,0,0,0.8), 0 1px 4px rgba(0,0,0,0.9)'}}>
              Restaurant à Moorea
            </p>
            <div className="flex items-center justify-center gap-4 text-xl sm:text-2xl text-white font-light tracking-wide" style={{textShadow: '0 1px 8px rgba(0,0,0,0.8)'}}>
              <span>terrasse</span>
              <span className="text-emerald-300">•</span>
              <span>cuisine</span>
              <span className="text-emerald-300">•</span>
              <span>cocktails</span>
            </div>
          </div>

          {/* Enhanced Badges */}
          <div className="flex flex-wrap justify-center gap-3 py-4">
            {[
              { icon: 'ri-goblet-line', text: 'Terrasse' },
              { icon: 'ri-parking-box-line', text: 'Parking gratuit' },
              { icon: 'ri-wheelchair-line', text: 'Accessible PMR' },
              { icon: 'ri-cake-3-line', text: 'Café & desserts top' }
            ].map((badge, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-white/20 backdrop-blur-lg border border-white/30 px-5 py-2.5 rounded-full shadow-lg hover:bg-white/30 hover:scale-105 transition-all duration-300"
              >
                <i className={`${badge.icon} text-lg text-white`}></i>
                <span className="text-sm font-medium text-white whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>

          {/* Enhanced Description */}
          <div className="relative max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-emerald-500/25 via-emerald-400/20 to-emerald-500/25 backdrop-blur-md border border-emerald-300/40 rounded-full px-10 py-6 shadow-2xl">
              <p className="text-xl text-white font-light leading-relaxed text-center">
                <span className="inline-flex items-center gap-3">
                  <span className="text-emerald-300">✦</span>
                  <span>Ambiance décontractée, agréable et calme</span>
                  <span className="text-emerald-300">✦</span>
                </span>
                <span className="block mt-2 text-lg text-emerald-200">
                  LGBTQ+ friendly 🌈
                </span>
              </p>
            </div>
            {/* Glow effect */}
            <div className="absolute inset-0 bg-emerald-400/10 blur-2xl rounded-full -z-10"></div>
          </div>

          {/* Enhanced Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <a
              href="tel:+68987735594"
              className="group flex items-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-full font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <span className="text-lg">+689 87 73 55 94</span>
            </a>

            <a
              href="https://www.google.com/maps/dir/?api=1&destination=KEIKI+Moorea"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-white/25 hover:bg-white/35 backdrop-blur-lg border border-white/40 text-white px-8 py-4 rounded-full font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-xl"></i>
              </div>
              <span className="text-lg">Itinéraire</span>
            </a>

            <a
              href="#avis-section"
              className="group flex items-center gap-3 bg-white/25 hover:bg-white/35 backdrop-blur-lg border border-white/40 text-white px-8 py-4 rounded-full font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('avis-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-star-line text-xl"></i>
              </div>
              <span className="text-lg">Voir les avis</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}